import { z } from "zod";

export const sortDimensionsConfigurationSchema = z.object({
	sortPolicy: z.string().optional(),
});
